module.exports = __webpack_public_path__ + "img/20200912_130842.0e76eaef.jpg";